import { Component, ViewContainerRef } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { TableListRequest, Where } from "../../../models/table-list-request.interface";
import { ActivatedRoute, Router } from "@angular/router";
import { ResizableModule, ResizeEvent } from "angular-resizable-element";
import { PaginatedListDataResponse } from "../../../models/paginated-list-data-response";
import { OperationService } from "../../../services/operations.service";
import { LoadingService } from "../../../services/loading.service";
import { ImportCargoItem } from "../../../models/cargo-item.interface";
import { ModalComponent } from "../../modal/modal.component";
import { AdvancedFilterComponentV2 } from "../../advanced-filter/advanced-filter-v2.component";
import itemConfig from "./config/item-filiing-config.json";
import { AdvancedFilterFieldInfo } from "../../../models/advanced-filter-config.interface";
import { CommonUtils } from "../../../utils/common-utils";
import { TableMeta } from "../../../models/table-meta.interface";
import { TosTableComponent } from "../../tos-table/tos-table.component";


@Component({
  selector: "app-item-filing",
  standalone: true,
  imports: [
    FormsModule,
    ResizableModule,
    TosTableComponent
  ],
  templateUrl: "./item-filing.component.html",
  styleUrl: "./item-filing.component.scss"
})
export class ItemFilingComponent {

    protected readonly itemConfig = itemConfig;

  searchTerm: any;
  focusSearch!: boolean;
  tableLoaded: boolean = false;
  tableMeta!: TableMeta;
  tableListData: PaginatedListDataResponse = {
    totalCount: 0,
    page: 0,
    limit: 0,
    records: []
  };
  sortColumn: string = "modifiedDate";
  totalTablePages: number = 0;
  currentTablePage: any;
  sortDirection: "asc" | "desc" = "desc";
  private rowsPerPage: number = 25;
  private currentPage: number = 0;
  tableListRequest: TableListRequest = {
    selectFields: [
      "id",
      "igmNo",
      "itemNo",
      "subItemNo",
      "igmDate",
      "blDate",
      "blNo",
      "vesselId",
      "viaNo",
      "portOfLoading",
      "modifiedDate",
    ],
    orderBy: {
      [this.sortColumn]: this.sortDirection
    },
    limit: this.rowsPerPage,
    includeTotal: true,
    page: this.currentPage
  };

  // table menu
  openMenuIndex: number | null = null;
  menuOptions = [
    { label: 'Edit', value: 'edit' },
    { label: 'View', value: 'view' },
  ];

  // filter
  filterData!: Where | null;
  rawFilterData!: Where | null;
  searchFilterData!: Where | null;
  isFilterApplied: boolean = false;

  allTableRecordsSelected: boolean = false;
  selectedItems: ImportCargoItem[] = [];
  private previousTerm: string = "";

  constructor(private router: Router,
              private route: ActivatedRoute,
              private operationService: OperationService,
              private loadingService: LoadingService,
              private viewContainerRef:ViewContainerRef) {}

  ngOnInit() {
    this.tableMeta = itemConfig.tableConfig;
  }

  fetchAllRecords() {
    this.loadingService.show('inline');
    this.operationService.getImportCargoList(this.tableListRequest).subscribe({
      next: (res: any) => {
        console.log("Response received:", res.data.records);
        this.tableListData = res.data;
        this.tableLoaded = true;
        this.loadingService.hide()
      },
      error: (error: Error) => {
        console.error("Error occurred:", error);
        this.tableLoaded = false;
        this.loadingService.hide()
      }
    });
  }



  addNewRecord() {
    this.router.navigate(['add-new'], { relativeTo: this.route });
  }

  isAllRecordsOfCurrentPageSelected() {
    return (
      this.allTableRecordsSelected ||
      (this.tableListData.records?.length > 0 &&
        this.tableListData.records?.every((item: ImportCargoItem) =>
          this.isSelected(item)
        ))
    );
  }

  toggleAllRecordsOfCurrentPageSelections(isChecked: any) {
    if (isChecked) {
      this.tableListData.records?.forEach((item) => {
        if (!this.isSelected(item)) {
          this.selectedItems.push(item);
        }
      });
    } else {
      this.tableListData.records?.forEach((item) => {
        this.selectedItems = this.selectedItems.filter((i) => i.id !== item.id);
      });
    }
  }


  onResizeEnd(event: ResizeEvent, column: string) {
    if (event.edges.right) {
      const columnHeader = document.querySelector(`th.${column}_th`) as HTMLElement;
      const columnCells = document.querySelectorAll(`td.${column}_td`);
      const newWidth = `${event.rectangle.width}px`;

      if (columnHeader) {
        columnHeader.style.width = newWidth;
      }

      columnCells.forEach(cell => {
        const cellHtml = cell as HTMLElement;
        cellHtml.style.width = newWidth;
      });
    }
  }


  isSelected(item: ImportCargoItem) {
    if (this.allTableRecordsSelected) {
      return true;
    } else {
      const recordIdx = this.selectedItems.findIndex((x) => x.id === item.id);
      if (recordIdx !== -1) {
        return true;
      } else {
        return false;
      }
    }
  }

  toggleSelection(item: ImportCargoItem) {
    if (!this.isSelected(item)) {
      this.selectedItems.push(item);
    } else {
      this.selectedItems = this.selectedItems.filter((i) => i.id !== item.id);
    }
  }

  handleMenuToggle(i: number) {
    this.openMenuIndex = this.openMenuIndex === i ? null : i;
  }

  handleMenuOptionSelection(event: any) {
    const { record, actionName } = event;
    this.handleOptionSelected(record, actionName);
  }

  handleOptionSelected(record: any, actionName: any) {
    console.log(record);
    const recordId = record.id;
    if (actionName === 'edit') {
      this.router.navigate([`edit/${recordId}`], { relativeTo: this.route });
    } else if (actionName === 'view') {
      this.router.navigate([`view/${recordId}`], { relativeTo: this.route });
    }
  }


  calculateTotalPages() {
    if (this.tableListRequest.where) {
      this.totalTablePages = Math.ceil(
        this.tableListData.totalCount / this.rowsPerPage
      );
    }
  }


}
